<script setup lang="ts">
import { ref } from 'vue';

import { useAuthenticationStore } from '@/store/useAuthenticationStore';
import { useCompetitionStore } from '@/store/useCompetitionStore';

import GradientButton from './GradientButton.vue';

const authStore = useAuthenticationStore();
const competitionStore = useCompetitionStore();
const emit = defineEmits(['onAuthorised']);
const username = ref('');
const password = ref('');

const onSubmit = async () => {
  const loggedIn = await authStore.signIn(username.value, password.value);
  await competitionStore.initalise();

  if (loggedIn) {
    emit('onAuthorised');
  }
};
</script>

<template>
  <form action="/user/login" method="post" @submit.prevent="onSubmit">
    <label htmlFor="login-user">Username:</label>
    <input type="text" v-model="username" name="username" placeholder="Username" id="login-user" />
    <label htmlFor="login-password">Password:</label>
    <input
      v-model="password"
      type="password"
      name="password"
      placeholder="Password"
      id="login-password"
    />
    <GradientButton type="submit">Sign In</GradientButton>
  </form>
</template>

<style lang="scss" scoped>
form {
  background: linear-gradient(180deg, white, #d9d9d9);
  background-color: #d9d9d9;
  border: 1px solid #afafaf;
  border-radius: 0 0 10px 0;
  box-shadow: 1px 1px 10px #b7b7b7;
  left: 0;
  padding: 10px;
  position: absolute;
  top: 50px;
  width: 235px;
  z-index: 15;
}

label {
  display: none;
}

input:not([type='submit']) {
  background-color: #fafafa;
  border-radius: 5px 5px 0 0;
  border: 1px solid #b4b4b4;
  box-shadow: 0px 0px 2px 0px #b9b9b9;
  display: block;
  font-size: 1rem;
  margin: 0 auto;
  outline: none;
  padding: 10px 15px;
  width: 200px;
}

input:last-of-type {
  border-top: 1px solid #f3f3f3;
  border-radius: 0 0 5px 5px;
}

button {
  float: right;
  margin: 10px 0 0 0;
}
</style>
